import { attachLaborBreakdownTablePaging } from '../labor-cost-breakdown-paging-helper';

class LaborExpenseCostBreakdownModalController {
  constructor(
    $uibModalInstance,
    $scope,
    reportPeriodLabel,
    laborExpensePie,
    laborPieChartOptions,
    laborExpenseBreakdownRows,
    formatStatCurrencyFn
  ) {
    'ngInject';
    const self = this;
    self.$uibModalInstance = $uibModalInstance;
    self.reportPeriodLabel = reportPeriodLabel;
    self.laborExpensePie = laborExpensePie;
    self.laborPieChartOptions = laborPieChartOptions;
    self.laborExpenseBreakdownRows = laborExpenseBreakdownRows;
    self.formatStatCurrency = formatStatCurrencyFn;

    attachLaborBreakdownTablePaging($scope, self, 'expense', function() {
      return self.laborExpenseBreakdownRows;
    }, '0 expense accounts');
  }

  close() {
    this.$uibModalInstance.dismiss();
  }
}

export default LaborExpenseCostBreakdownModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/modals/labor-expense-cost-breakdown-modal/labor-expense-cost-breakdown-modal.controller.js